import BrkthruBarChart from 'components/BrkthruBarChart/BarChartSelector'
export default BrkthruBarChart